module.exports = __webpack_public_path__ + "img/special-photo-04.dcb3f7cf.jpg";